import { useCallback, useEffect, useState } from "react";
import axios from "axios";

function nichesUrl() {
  return `${process.env.REACT_APP_BACKEND_URL}/api/auth/niches`;
}

export function legacyBrainToSignupChoice(brain) {
  if (brain === "roofing") return { family: "universal", nicheId: "roofing_company" };
  if (brain === "renovation") return { family: "universal", nicheId: "renovation_company" };
  if (brain === "real_estate") return { family: "real_estate", nicheId: null };
  return { family: null, nicheId: null };
}

export function signupCatalogErrorMessage(err) {
  const message = err?.response?.data?.message;
  if (typeof message === "string" && message) return message;
  return "Niche catalogue is unavailable.";
}

export function signupCatalogFailure(err) {
  return {
    message: signupCatalogErrorMessage(err),
    choice: null,
    code: null,
  };
}

export async function loadSignupNiches() {
  const response = await axios.get(nichesUrl());
  const data = response?.data;
  if (!data || data.status !== "ok" || !Array.isArray(data.niches)) {
    throw new Error("Niche catalogue is unavailable.");
  }
  return data.niches.map((row) => ({
    niche_id: row.niche_id,
    label: row.label,
    description: row.description,
  }));
}

export function canSubmitUniversalSignup({ catalogStatus, nicheId, niches }) {
  if (catalogStatus !== "ready" || typeof nicheId !== "string" || nicheId === "") return false;
  if (!Array.isArray(niches)) return false;
  return niches.some((row) => row && row.niche_id === nicheId);
}

export function useSignupNiches() {
  const [status, setStatus] = useState("loading");
  const [niches, setNiches] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  const load = useCallback(async () => {
    setStatus("loading");
    setErrorMessage("");
    try {
      const next = await loadSignupNiches();
      setNiches(next);
      setStatus("ready");
    } catch (err) {
      setNiches([]);
      setErrorMessage(signupCatalogErrorMessage(err));
      setStatus("error");
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { status, niches, errorMessage, retry: load };
}
